import { Injectable } from "@angular/core";
import { RestApiService } from '../rest-api.service';
import { Observable } from 'rxjs';
import { IDashboardInputModel, IFlexDCIInputModel, IICInputModel, IProjectDashboardInputModel, IProjectDocDashboardInputModel, IProjDashboardInputModel, IProjDocDashboardInputModel, IGFCDrawingInputModel, IJobMHInputModel, IManHourInputModel, IHomeDashboardInputModel } from 'src/app/ViewModel/DashboardModel';
import { PendingDrawingStatus } from "src/app/ViewModel/Tender-Quantity.Model";


@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    private getEDMSDashboardDetailsUrl = 'Dashboard/GetEDMSDashboardDetails';
    private getICDetailsUrl = 'Dashboard/GetICDetails';
    private getFlexDCIDetailsUrl = 'Dashboard/GetFlexDCIDetails';
    private getEDMSProjectDashboardDetailsUrl = 'Dashboard/GetEDMSProjectDashboardDetails';
    private getEDMSProjectDashboardDocDetailsUrl = 'Dashboard/GetEDMSProjectDashboardDocDetails';
    private getProjDashboardUrl = 'Dashboard/GetProjectDashboardDetails';
    private getProjDocDashboardUrl = 'Dashboard/GetProjectDashboardDocDetails';
    private getdrawingGFCDashboardUrl = 'Dashboard/GetDrawingGFCDetails';
    private getdciAdherenceUrl = 'Dashboard/GetDCIScheduleAdherenceDetails';
    private getdciStageWiseeUrl = 'Dashboard/GetStageWiseDocDetails';
    private getdciRevWiseUrl = 'Dashboard/GetRevisionWiseDocDetails';
    private getdciDiscWiseUrl = 'Dashboard/GetDisciplineWiseDocDetails';
    private getStageRevWiseUrl = 'Dashboard/GetStageRevisionWiseDocDetails';
    private getJobMHDetailsUrl = 'Dashboard/GetEDRCProjectMHDetails';
    private getManHourDetailsUrl = 'Dashboard/GetManHourDetails';
    public getPendingDrawingStatusUrl = 'Dashboard/getPendingDrawingStatus';
    getEDMSHomeDashboardDetails = 'Dashboard/GetEDMSHomeDashboardDetails';

    constructor(private restAPTService: RestApiService) { }


    public GetEDMSDashboardDetails(icdetails?: IDashboardInputModel): Observable<any> {

        return this.restAPTService.new_POST(this.getEDMSDashboardDetailsUrl, icdetails);
    }

    public GetICDetails(icdetails?: IICInputModel): Observable<any> {

        return this.restAPTService.new_POST(this.getICDetailsUrl, icdetails);
    }

    public GetFlexDCIDetails(flexDCIdetails?: IFlexDCIInputModel): Observable<any> {

        return this.restAPTService.new_POST(this.getFlexDCIDetailsUrl, flexDCIdetails);
    }

    public GetEDMSProjectDashboardDetails(projdetails?: IProjectDashboardInputModel): Observable<any> {

        return this.restAPTService.new_POST(this.getEDMSProjectDashboardDetailsUrl, projdetails);
    }

    public GetEDMSProjectDashboardDocDetails(projdetails?: IProjectDocDashboardInputModel): Observable<any> {

        return this.restAPTService.new_POST(this.getEDMSProjectDashboardDocDetailsUrl, projdetails);
    }

    public GetProjDashboardDetails(projdetails?: IProjDashboardInputModel): Observable<any> {

        return this.restAPTService.new_POST(this.getProjDashboardUrl, projdetails);
    }

    public GetProjDashboardDocDetails(projdetails?: IProjDocDashboardInputModel): Observable<any> {

        return this.restAPTService.new_POST(this.getProjDocDashboardUrl, projdetails);
    }

    public GetDrawingGFCDetails(projdetails?: IGFCDrawingInputModel): Observable<any> {

        return this.restAPTService.new_POST(this.getdrawingGFCDashboardUrl, projdetails);
    }

    public GetDCiAdherenceDetails(projdetails?: IProjDashboardInputModel): Observable<any> {

        return this.restAPTService.new_POST(this.getdciAdherenceUrl, projdetails);
    }

    public GetStageWiseDocDetails(projdetails?: IProjDashboardInputModel): Observable<any> {

        return this.restAPTService.new_POST(this.getdciStageWiseeUrl, projdetails);
    }

    public GetRevisionWiseDocDetails(projdetails?: IProjDashboardInputModel): Observable<any> {

        return this.restAPTService.new_POST(this.getdciRevWiseUrl, projdetails);
    }

    public GetDiscWiseDocDetails(projdetails?: IProjDashboardInputModel): Observable<any> {

        return this.restAPTService.new_POST(this.getdciDiscWiseUrl, projdetails);
    }

    public GetStageRevisionWiseDocDetails(projdetails?: IProjDashboardInputModel): Observable<any> {

        return this.restAPTService.new_POST(this.getStageRevWiseUrl, projdetails);
    }

    public GetJobWiseMHDetails(projdetails?: IJobMHInputModel): Observable<any> {

        return this.restAPTService.new_POST(this.getJobMHDetailsUrl, projdetails);
    }
    public GetManHourDetails(manHourDetails?: IManHourInputModel): Observable<any> {

        return this.restAPTService.new_POST(this.getManHourDetailsUrl, manHourDetails);
    }
    public GetPendingDrawingStatus(PendingDrawingStatus?: PendingDrawingStatus): Observable<any> {

        return this.restAPTService.new_POST(this.getPendingDrawingStatusUrl, PendingDrawingStatus);
    }

    public GetEDMSHomeDashboardDetails(HomeDashboardInputModel: IHomeDashboardInputModel): Observable<any> {
        return this.restAPTService.new_POST(this.getEDMSHomeDashboardDetails, HomeDashboardInputModel);
    }
}